import { Grid, List, makeStyles, Theme, Typography } from "@material-ui/core";
import { useDocumentStore } from "@roc/feature-documents";
import { observer } from "mobx-react";
import { divider, listItem } from "../cardComponents/payoffCardListItem";
import { isNil } from "@roc/feature-utils";
import { formatCurrency } from "@roc/ui/utils";

const useStyles = makeStyles((theme: Theme) => ({
}));

export const PayoffProtectiveAdvancesMoreInfo = observer(({ }) => {
  const classes = useStyles();

  const {
    documentStore: {
      documentFormStore: { payoffCalculatorStore },
    },
  } = useDocumentStore();

  return (
    <div>
      <Grid container direction="row" spacing={1}>
        {Object.keys(payoffCalculatorStore?.payoffCalculatorData?.receivablesReport)?.map(entity => {
          return (
            <>
              <Grid item xs={12}>
                <Typography variant="h6">
                  {entity}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <List style={{ padding: '0px' }}>
                  {Object.keys(payoffCalculatorStore?.payoffCalculatorData?.receivablesReport[entity])?.map(fee => {
                    return (
                      <>
                        {listItem(fee, !isNil(payoffCalculatorStore?.payoffCalculatorData?.receivablesReport[entity][fee]) ? formatCurrency(payoffCalculatorStore?.payoffCalculatorData?.receivablesReport[entity][fee]) : '-')}
                        {divider}
                      </>
                    );
                  })}
                </List>
              </Grid>
            </>
          );
        })}
      </Grid>
    </div>
  );
});
